import axios from "axios";
import token from "./axios.canceltoken";
import NewSecurityManager from "diginity-auth-manager";

token.cancel = axios.CancelToken;
// Warn if overriding existing method -------------------
if (Array.prototype.equals)
  console.warn(
    "Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code."
  );
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array, type) {
  // if the other array is a false value, return
  if (!array) {
    return false;
  }
  var $this = this.sort();
  var $array = array.sort();
  // compare lengths - can save a lot of time
  if ($array.length > $this.length) {
    return false;
  }
  var hasVal = [];
  $array.forEach((element) => {
    if (type == "Album" || type == "Year") {
      hasVal.push($this.indexOf(element) > -1);
    } else {
      if ($this.indexOf(element) == -1) {
        hasVal.push(false);
      } else {
        hasVal.push(true);
      }
    }
  });
  if (hasVal.indexOf(false) !== -1) {
    return false;
  }
  return true;
};
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {
  enumerable: false,
});
//----------------------------------------------------
// language
const language = ({ commit }, lang) => {
  commit("LANGUAGE", lang);
};
const INIT_TOKEN = async ({ state }) => {
  // initialize security module
  NewSecurityManager.init(appId, {
    ipUrl: HOST + "/gateway/ip",
    // trace: true,
  });

  // generate token with usr/pwd
  const generateToken = await NewSecurityManager.generate(x_usr, x_pwd);

  // logon request
  const { data } = await axios.post(
    state.url.endpoint + "op=logon",
    JSON.stringify({ token: generateToken })
  );
};

//!
//! subscribe email
//!

const subscribe = async ({ commit }, email) => {
  const REQUEST = await axios.get(
    "https://fakedata-1.firebaseio.com/status.json"
  );
  return REQUEST.data;
};

// static content
const static_content = async ({ commit, state }) => {
  const REQUEST = await axios.post(
    `${state.url.endpoint}op=queryAdvancedTextContent`,
    {
      token: await NewSecurityManager.generate(),
      columns: "StaticContent.Key,Key,Body,Language",
      query: "StaticContent.ID != @p0",
      args: [null],
    }
  );
  // console.log('STATIC_CONTENT', eval(REQUEST.data));
  commit("STATIC_CONTENT", eval(REQUEST.data));
};

// music player
const music_playlist = async ({ commit, getters, state }) => {
  let musicList = [];
  const REQUEST = await axios.post(
    `${state.url.endpoint}op=queryPlaylistItem`,
    {
      token: await NewSecurityManager.generate(),
      query: "IsActive = @p0",
      args: [true],
    }
  );
  //! console.log(REQUEST.data);
  await REQUEST.data.All.find((item) => {
    musicList.push({
      pic: "/assets/sezenaksu_crop.png",
      title: item.Key,
      src: getters.file(item.SongLink),
      artist: `${item.Album} (${item.AlbumYear})`,
    });
  });
  await commit("MUSIC_PLAYLIST", musicList);
};

// homepage list
const homepage_list = async ({ commit, state }) => {
  commit("HOMEPAGE", []);
  const REQUEST = await axios.post(`${state.url.endpoint}op=queryPageBox`, {
    token: await NewSecurityManager.generate(),
    query: "Parent.Language = @p0 AND Parent.PageType = @p1",
    args: [state.language, "homepage"],
  });
  //! console.log(REQUEST.data)
  if (REQUEST.data.All.length) {
    commit(
      "HOMEPAGE",
      REQUEST.data.All.sort((a, b) => {
        return a.Postion - b.Position;
      })
    );
  } else {
    commit("HOMEPAGE", undefined);
  }
};

// slider list
const slider_list = async ({ commit, state }) => {
  const REQUEST = await axios.post(`${state.url.endpoint}op=querySlider`, {
    token: await NewSecurityManager.generate(),
    query: "",
    args: [],
  });
  //! console.log(REQUEST.data);
  commit(
    "SLIDER",
    REQUEST.data.All.sort((a, b) => {
      return a.Position - b.Position;
    })
  );
};

// announcements list
const announcements_list = async ({ commit, state }) => {
  commit("ANNOUNCEMENTS", []);
  const REQUEST = await axios.post(
    `${state.url.endpoint}op=queryAdvancedTextContent`,
    {
      token: await NewSecurityManager.generate(),
      columns: "ID,Body,Date,Language,Key,Announcement.ValidityEndDate",
      query:
        "Language = @p0 AND Announcement.Type = @p1 AND Announcement.Date > @p2 AND Announcement.Date <= @p3 ORDER BY Announcement.Date",
      args: [state.language, "general", new Date(2007, 0, 1), new Date()],
    }
  );
  // console.log(eval(REQUEST.data));
  const List = eval(REQUEST.data) ? eval(REQUEST.data) : undefined;
  commit("ANNOUNCEMENTS", List);
};

const sezenden_list = async ({ commit, state }) => {
  commit("SEZENDEN", []);
  const REQUEST = await axios.post(`${state.url.endpoint}op=queryTextContent`, {
    token: await NewSecurityManager.generate(),
    query: "Language = @p0 AND Announcement.Type = @p1",
    args: [state.language, "sezenden"],
  });
  // console.log(REQUEST.data);
  const List = REQUEST.data.All ? REQUEST.data.All : undefined;
  commit("SEZENDEN", List);
};

const press_list = async ({ state, commit }, params) => {
  try {
    if (token.press !== undefined) {
      // cancel axios request
      token.press();
    }
    // split params (from to)
    const from = params.year ? parseInt(params.year.split("_")[0]) : 2000;
    const to = params.year ? parseInt(params.year.split("_")[1]) : undefined;
    // columns
    const columns =
      "PressClipping.ID,PressClipping.Date,PressClipping.Name,PressClipping.ImageLink,Key,Body,Language";
    //query
    const query = `Language = @p0 AND PressClipping.Category = @p1 AND PressClipping.Date >= @p2 ${
      to ? "AND PressClipping.Date <=@p3" : ""
    }`;
    let args = [state.language, params.category, new Date(from, 0, 1)];
    if (to) args.push(new Date(to, 11, 31));

    commit("PRESS_LIST", []);
    const REQUEST = await axios.post(
      `${state.url.endpoint}op=queryAdvancedTextContent`,
      {
        token: await NewSecurityManager.generate(),
        columns: columns,
        query: query,
        args: args,
      },
      {
        cancelToken: new token.cancel(function executor(c) {
          token.press = c;
        }),
      }
    );
    const data = eval(REQUEST.data);
    // console.log(data);
    commit("PRESS_LIST", data.length > 0 ? data : undefined);
  } catch (e) {}
};

const press_extra_images = async ({ state, commit }, array) => {
  commit("PRESS_EXTRA_IMAGES", []);
  let images = [];
  await array.forEach((item) => {
    axios
      .get(
        `${
          state.url.endpoint_host
        }/files/pub/all?id=${item}&appKey=000000003z7H`
      )
      .then((REQUEST) => {
        images.push({
          parent_id: item,
          images: REQUEST.data,
        });
      });
  });
  commit("PRESS_EXTRA_IMAGES", images);
};

const allworks_home = async ({ commit, state }) => {
  commit("ALLWORKS_HOME", []);
  const REQUEST = await axios.post(`${state.url.endpoint}op=queryPageBox`, {
    token: await NewSecurityManager.generate(),
    query: "Parent.Language = @p0 AND Parent.PageType = @p1",
    args: [state.language, "works"],
  });
  commit(
    "ALLWORKS_HOME",
    REQUEST.data.All
      ? REQUEST.data.All.sort((a, b) => {
          return a.Position - b.Position;
        })
      : undefined
  );
};

const albums_list = async ({ commit, state }, params) => {
  try {
    if (token.albums !== undefined) {
      token.albums();
    }
    commit("ALBUMS_LIST", []);
    const REQUEST = await axios.post(
      `${state.url.endpoint}op=queryAlbum`,
      {
        token: await NewSecurityManager.generate(),
        query: "Category = @p0",
        args: [params.type],
      },
      {
        cancelToken: new token.cancel(function executor(c) {
          token.albums = c;
        }),
      }
    );
    token.albums = undefined;
    // console.log(REQUEST.data.All)
    commit("ALBUMS_LIST", REQUEST.data.All);
  } catch (e) {}
};

const album_tracklist = async ({ commit, state }, id) => {
  commit("ALBUM_TRACKLIST", []);
  const REQUEST = await axios.post(`${state.url.endpoint}op=querySong`, {
    token: await NewSecurityManager.generate(),
    query: "Album.ID = @p0",
    args: [id],
  });

  const requestData = REQUEST.data.All;
  // Boş şarkı sözleri için 'MainSong' aracılığı ille doldurma
  for (let dataIndex = 0; dataIndex < requestData.length; dataIndex++) {
    const element = requestData[dataIndex];
    if (element.MainSong) {
      // main song prop dolu ise bu nesnedeki ID ile şarkı sözü isteği yap ve Lyrics nesnesini doldur
      const REQUEST_LYRICS = await axios.post(
        `${state.url.endpoint}op=querySong`,
        {
          token: await NewSecurityManager.generate(),
          query: "ID = @p0",
          args: [element.MainSong.ID],
        }
      );
      element.Lyrics = REQUEST_LYRICS.data.All[0].Lyrics;
    }
  }

  // console.log(REQUEST.data.All)
  commit("ALBUM_TRACKLIST", requestData);
};

const autocomplete_songs = async ({ state, commit }, value) => {
  try {
    if (token.search !== undefined) {
      token.search("aaa");
    }
    let result = [];
    const AUTOCOMPLETE = await axios.post(
      `${state.url.endpoint}op=queryAlbum`,
      {
        token: await NewSecurityManager.generate(),
        query: "Key LIKE @p0",
        args: [`%${value}%`],
      },
      {
        cancelToken: new token.cancel(function executor(c) {
          token.search = c;
        }),
      }
    );
    token.search = undefined;
    let x = [];
    AUTOCOMPLETE.data.All.find((item) => {
      result.push({
        id: item.ID,
        value: item.Key,
      });
    });
    return result.sort().reverse();
  } catch (e) {}
};

const album_images = async ({ commit, state }, id) => {
  commit("ALBUM_IMAGES", []);
  const REQUEST = await axios.get(
    `${state.url.endpoint_host}/files/pub/all?id=${id}&appKey=000000003z7H`
  );
  //! console.log(REQUEST);
  commit("ALBUM_IMAGES", REQUEST.data);
};

const select_options = async ({ state, commit }, select) => {
  const REQUEST = await axios.post(`${state.url.endpoint}op=queryContributor`, {
    token: await NewSecurityManager.generate(),
    query: "",
    args: [],
  });
  let data = {
    work: [],
    performer: [],
    lyricist: [],
    editor: [],
    composer: [],
  };
  if (REQUEST.data.All) {
    REQUEST.data.All.find((item) => {
      /* editor */
      if (item.EditorCode !== "NULL") {
        data.editor.push({
          id: item.ID,
          value: item.Key,
        });
      }
      /* composer */
      if (item.ComposerCode !== "NULL") {
        data.composer.push({
          id: item.ID,
          value: item.Key,
        });
      }
      /* lyricist */
      if (item.LyricistCode !== "NULL") {
        data.lyricist.push({
          id: item.ID,
          value: item.Key,
        });
      }
      /* performer */
      if (item.PerformerCode !== "NULL") {
        data.performer.push({
          id: item.ID,
          value: item.Key,
        });
      }
    });
  }

  // Sezen aksu parametresini ilk sırada getirme
  if (data.performer) {
    function firstItemFix(dataArray) {
      return dataArray.reduce((ar, el) => {
        return el.value.toLocaleLowerCase() == "sezen aksu"
          ? [el, ...ar]
          : [...ar, el];
      }, []);
    }
    data.performer = firstItemFix(data.performer);
    data.lyricist = firstItemFix(data.lyricist);
    data.editor = firstItemFix(data.editor);
    data.composer = firstItemFix(data.composer);
  }

  commit("SELECT_OPTIONS", data);
};

const search_request = async ({ state, commit }, params) => {
  debugger;
  if (params == "empty") {
    return commit("SEARCH_SONGS", []);
  }
  // console.log(JSON.stringify(params));

  let criteria = [];
  let intersectCriteria = [];
  let values = [];
  for (const i in params) {
    if (
      i == "performer" ||
      i == "composer" ||
      i == "lyricist" ||
      i == "editor"
    ) {
      const arr = params[i];
      if (arr.length > 0) {
        let criterion = "SongContributors.Key = @p" + values.length + " AND ";
        values.push(i[0].toUpperCase() + i.substring(1));
        let innerCriterion = [];
        arr.forEach((element, index) => {
          innerCriterion.push(
            "SongContributors.Contributor.ID = @p" + values.length
          );
          values.push(element.id);
        });
        criterion += "(" + innerCriterion.join(" OR ") + ")";
        intersectCriteria.push("(" + criterion + ")");
      }
    } else if (i == "album") {
      let innerCriterion = [];
      params.album.forEach((element) => {
        innerCriterion.push("Album.ID = @p" + values.length);
        values.push(element.id);
      });
      if (innerCriterion.length > 0)
        criteria.push("(" + innerCriterion.join(" OR ") + ")");
    } else if (i == "year") {
      let innerCriterion = [];
      params.year.forEach((element) => {
        innerCriterion.push(
          "(Album.Date >= @p" +
            values.length +
            " AND Album.Date < @p" +
            (values.length + 1) +
            ")"
        );
        values.push(new Date(parseInt(element.label), 0, 1));
        values.push(new Date(parseInt(element.label) + 1, 0, 1));
      });
      if (innerCriterion.length > 0)
        criteria.push("(" + innerCriterion.join(" OR ") + ")");
    }
  }

  // String  query
  const criteriaTitle =
    params.queryTitle.length > 0 ? `Key LIKE @p${values.length}` : undefined;

  if (params.queryTitle.length > 0) {
    values.push(`%${params.queryTitle}%`);
  }

  const criteriaLyrics =
    params.queryLyrics.length > 0
      ? `Lyrics LIKE @p${values.length} OR MainSong.Lyrics LIKE @p${
          values.length
        }`
      : undefined;
  if (params.queryLyrics.length > 0) {
    values.push(`%${params.queryLyrics}%`);
  }

  // sadece title girilmişse
  if (criteriaTitle && !criteriaLyrics) {
    criteria.push(`(${criteriaTitle})`);
  } else if (criteriaLyrics && !criteriaTitle) {
    criteria.push(`(${criteriaLyrics})`);
  } else if (criteriaLyrics && criteriaTitle) {
    criteria.push(`(${criteriaTitle} AND ${criteriaLyrics})`);
  }

  // if (params.queryTitle.length > 0) {
  //   criteria.push(
  //     "(Key LIKE @p" +
  //       values.length +
  //       " OR Lyrics LIKE @p" +
  //       values.length +
  //       ")"
  //   );
  //   values.push("%" + params.query + "%");
  // }

  var query = null;
  if (intersectCriteria.length > 0) {
    if (criteria.length > 0) {
      var cr = criteria.join(" AND ");
      intersectCriteria.forEach((element, index) => {
        intersectCriteria[index] = "(" + element + " AND " + cr + ")";
      });
    }
    query = intersectCriteria.join(" INTERSECT ");
  } else {
    query = criteria.join(" AND ");
  }

  commit("SEARCH_SONGS", []);
  const REQUEST = await axios.post(`${state.url.endpoint}op=querySong`, {
    token: await NewSecurityManager.generate(),
    query: query,
    args: values,
  });

  const requestData = REQUEST.data.All;
  // Boş şarkı sözleri için 'MainSong' aracılığı ille doldurma
  for (let dataIndex = 0; dataIndex < requestData.length; dataIndex++) {
    const element = requestData[dataIndex];
    if (element.MainSong) {
      // main song prop dolu ise bu nesnedeki ID ile şarkı sözü isteği yap ve Lyrics nesnesini doldur
      const REQUEST_LYRICS = await axios.post(
        `${state.url.endpoint}op=querySong`,
        {
          token: await NewSecurityManager.generate(),
          query: "ID = @p0",
          args: [element.MainSong.ID],
        }
      );
      element.Lyrics = REQUEST_LYRICS.data.All[0].Lyrics;
    }
  }
  //!----------------------------------
  var pattern = [
    "Album",
    "Composer",
    "Lyricist",
    "Editor",
    "Performer",
    "Year",
  ];

  var cleanParam = createObj();
  for (var pr in params) {
    if (typeof params[pr] !== "string") {
      var upperKey = pr.substr(0, 1).toLocaleUpperCase() + pr.substr(1);
      params[pr].find((item) => {
        cleanParam[upperKey].push(
          typeof item.value == "string"
            ? item.value.toLocaleLowerCase()
            : item.value
        );
      });
    }
  }
  var exactMatch = []; // <- exact match
  requestData.find((item) => {
    // performer,lyricist,editor,composer split
    var Contributors_Array =
      item.Contributors !== null ? item.Contributors.split(",") : [];

    var fix_item = replaced(Contributors_Array, pattern); // Contrubitor cleaning
    fix_item.Album = item.AlbumName.toLocaleLowerCase();
    fix_item.Year = item.AlbumYear;

    var matching = [];
    for (var c in fix_item) {
      for (var p in cleanParam) {
        if (c == p && cleanParam[p].length > 0) {
          // equals params
          if (c == "Album" || c == "Year") {
            matching.push(cleanParam[c].indexOf(fix_item[p]) > -1);
          } else {
            matching.push(fix_item[p].equals(cleanParam[c], "match"));
          }
        }
      }
    }

    if (matching.indexOf(false) == -1) {
      exactMatch.push(item); // push exact match item
    }
    //  else {
    // missMatch.push(item);
    // }
  });

  //!----------------------------------
  commit("SEARCH_SONGS", exactMatch.length ? exactMatch : undefined);

  return false;
};

/* Functions Serach */
var createObj = () => {
  return {
    Composer: [],
    Lyricist: [],
    Editor: [],
    Performer: [],
    Album: [],
    Year: [],
  };
};
var replaced = (item, pattern) => {
  let end = createObj();
  item.find((s) => {
    pattern.forEach((ptr) => {
      if (s.match(ptr)) {
        end[ptr].push(s.replace(ptr + ":", "").toLocaleLowerCase());
      }
    });
  });
  return end;
};
/* ---------------- */

const products_list = async ({ state, commit }) => {
  const REQUEST = await axios.post(`${state.url.endpoint}op=queryHandcraft`, {
    token: await NewSecurityManager.generate(),
    query: "",
    args: [],
  });

  commit("PRODUCTS_LIST", REQUEST.data.All ? REQUEST.data.All : undefined);
};

const videopage_menu = async ({ state, commit }) => {
  const REQUEST = await axios.post(
    `${state.url.endpoint}op=queryAdvancedVideoGallery`,
    {
      token: await NewSecurityManager.generate(),
      columns: "TextContents.Key,TextContents.Language,ID,Parent.ID,Position",
      query: "",
      args: [],
    }
  );
  // console.log(eval(REQUEST.data));
  commit(
    "VIDEOPAGE_MENU",
    eval(REQUEST.data).sort((a, b) => {
      return a.position - b.position;
    })
  );
};

const videos_list = async ({ state, commit }, type) => {
  try {
    if (token.videos !== undefined) {
      token.videos("fenerbahçe");
    }
    commit("VIDEOS_LIST", []);
    const REQUEST = await axios.post(
      `${state.url.endpoint}op=queryVideo`,
      {
        token: await NewSecurityManager.generate(),
        query: "Parent.ID = @p0 ORDER BY Date DESC",
        args: [type],
      },
      {
        cancelToken: new token.cancel(function executor(c) {
          token.videos = c;
        }),
      }
    );
    token.videos = undefined;
    // console.log(REQUEST.data.All.sort((a, b) => {
    //   return new Date(b.Date) - new Date(a.Date);
    // }));
    commit(
      "VIDEOS_LIST",
      REQUEST.data.All.length
        ? REQUEST.data.All.sort((a, b) => {
            return new Date(b.Date) - new Date(a.Date);
          })
        : undefined
    );
  } catch (e) {}
};

const photos_menu = async ({ state, commit }) => {
  const REQUEST = await axios.post(
    `${state.url.endpoint}op=queryAdvancedPhotoGallery`,
    {
      token: await NewSecurityManager.generate(),
      columns: "TextContents.Key,TextContents.Language,ID,Key,Position",
      query: "",
      args: [],
    }
  );
  commit(
    "PHOTOSPAGE_MENU",
    eval(REQUEST.data).sort((a, b) => {
      return a.position - b.position;
    })
  );
};

const photos_list = async ({ state, commit }) => {
  try {
    if (token.photos !== undefined) {
      token.photos();
    }
    const REQUEST = await axios.post(
      `${state.url.endpoint}op=queryPhoto`,
      {
        token: await NewSecurityManager.generate(),
        query: "",
        args: [],
      },
      {
        cancelToken: new token.cancel(function executor(c) {
          token.photos = c;
        }),
      }
    );
    token.photos = undefined;
    commit("PHOTOS_LIST", REQUEST.data.All ? REQUEST.data.All : undefined);
  } catch (e) {}
};

const send_form = async ({ state }, form_data) => {
  const REQUEST = await axios.post(`${state.url.endpoint}op=createComment`, {
    token: await NewSecurityManager.generate(),
    e: form_data,
  });
  return REQUEST.data.HasErrors;
};

const updates = async ({ state, commit }, language) => {
  commit("UPDATES", []);
  const REQUEST = await axios.post(`${state.url.endpoint}op=querySiteUpdate`, {
    token: await NewSecurityManager.generate(),
    query: "Language = @p0 ORDER BY Key DESC",
    args: [language],
  });
  // console.log('updates');
  commit("UPDATES", REQUEST.data.All ? REQUEST.data.All : undefined);
};

export default {
  INIT_TOKEN,
  language,
  subscribe,
  static_content,
  music_playlist,
  homepage_list,
  slider_list,
  announcements_list,
  sezenden_list,
  press_list,
  press_extra_images,
  allworks_home,
  albums_list,
  album_tracklist,
  album_images,
  select_options,
  autocomplete_songs,
  search_request,
  products_list,
  videopage_menu,
  videos_list,
  photos_menu,
  photos_list,
  send_form,
  updates,
};
